/**
 *   *@fileDescription: This file contains the environment configuration for the development environment.
 */

export const environment: any = {
    production: false,
    baseURL: 'https://driver-be-dev.playoctopus.com/api/v1/',
    baseURLV2: 'https://driver-be-dev.playoctopus.com/api/v2/',
    baseURLOperations: 'https://driver-be-dev.playoctopus.com/api/operations/v1/',
    redirectionUrl: 'https://dev-operations.playoctopus.com/',
    url: 'https://driver-dev-django.playoctopus.com/',
    helpUrl: 'https://playoctopus.com/help',
    resetUrl: 'https://driver-dev-django.playoctopus.com/reset',
    PRIZEOUT_ENV: 'sandbox',
    PRIZEOUT_NAME: 'Octopus Interactive',
    platform: 'DEV',
    COOKIE_NAME: 'driverDashboardDevAccess',
    ADMIN_COOKIE: 'isAdminDevAccess',
    CCS_COOKIE: 'isCcsDevAccess',
    FILTER_COOKIE: 'operationsFilterDevAccess',
    SEARCH_PAGE_COOKIE: 'operationsSearchDevAccess',
    UBER_LINK:
        'https://auth.uber.com/oauth/v2/authorize?response_type=code&client_id=cKc9lFSeZRJBdcqz4uxEmodatSIXBTcL&redirect_uri=https://driver-dev-django.playoctopus.com/uber/authorize',
    UBER_LOGOUT_URL: 'https://auth.uber.com/login/logout',
    env: 'dev',
    allowedTracingUrls: [
        'https://driver-be-dev.playoctopus.com',
        /https:\/\/.*\.driver-be-dev.playoctopus\.com/,
        (url: string) =>
            url.startsWith('https://driver-be-dev.playoctopus.com'),
    ],
    UBER_CONNECT_DASHBOARD_FLAG: true,
    UBER_CONNECT_SIGNUP_FLAG: true,
    ALLOWED_DOMAINS: ['qburst.com', 'playoctopus.com', 't-mobile.com'],
    uberLifetimeZeroTrips: 'LIFETIME_TRIPS_COHORT_COHORT_ZERO',
    uberRecentZeroTrips: 'RECENT_ONLINE_ACTIVITY_COHORT_ZERO',
    leaderboardFetchUrl: 'https://driver-be-reader-dev.playoctopus.com/api/v1/leaderboard/top-drivers',
    ENFORCE_UBER_CONNECT_FLAG: true,
};
